import { RestrictionsType } from '@shared/ui/Restrictions';
import { createAction } from 'redux-actions';

export const SET_RESTRICTIONS = 'SET_RESTRICTIONS';
export const SET_RESTRICTIONS_LOADING = 'SET_RESTRICTIONS_LOADING';
export const SET_RESTRICTIONS_ACCEPTED = 'SET_RESTRICTIONS_ACCEPTED';

export const setRestrictions = createAction<RestrictionsType[]>(SET_RESTRICTIONS);
export const setRestrictionsLoading = createAction<boolean>(SET_RESTRICTIONS_LOADING);
export const setRestrictionsAccepted = createAction<boolean>(SET_RESTRICTIONS_ACCEPTED);

export type SetRestrictionsAction = { type: typeof SET_RESTRICTIONS; payload: RestrictionsType[] };
export type SetRestrictionsLoadingAction = { type: typeof SET_RESTRICTIONS_LOADING; payload: boolean };
export type SetRestrictionsAcceptedAction = { type: typeof SET_RESTRICTIONS_ACCEPTED; payload: boolean };

export type ActionRestrictionsTypes =
	| SetRestrictionsAction
	| SetRestrictionsLoadingAction
	| SetRestrictionsAcceptedAction;
